import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import tokens from '../theme/tokens';

ChartJS.register(ArcElement, Tooltip, Legend);

// Paleta harmonizada com a marca para os gráficos.
export const chartPalette = [
  tokens.color.brand,
  tokens.color.inkSoft,
  tokens.color.gold,
  tokens.color.success,
  tokens.color.info,
  '#9CA3AF',
];

const options = {
  cutout: '62%',
  plugins: {
    legend: { position: 'bottom', labels: { usePointStyle: true, boxWidth: 8, padding: 16, font: { family: 'Inter' } } },
  },
};

const PieChart = ({ data }) => {
  const themed = {
    ...data,
    datasets: data.datasets.map((dataset) => ({
      ...dataset,
      backgroundColor: chartPalette.slice(0, (dataset.data || []).length || chartPalette.length),
      borderColor: '#fff',
      borderWidth: 2,
    })),
  };
  return <Doughnut data={themed} options={options} />;
};

export default PieChart;
